var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-area"},[_c('sidebar'),_c('navigation'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('adminfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }